import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { URLSearchParams } from '@angular/http';
import { ActivatedRoute } from '@angular/router'

import { SessionService } from '../api/session.service';
import { Survey } from '../api/resources/survey';
import { SurveyService } from '../api/resources/survey.service';
import { AgencyLocationService } from '../api/resources/agency-location.service';

@Component({
  selector: 'app-survey-list',
  templateUrl: './survey-list.component.html',
  styleUrls: ['./survey-list.component.less'],
  providers: [
    SurveyService,
    SessionService,
    AgencyLocationService
  ]
})
export class SurveyListComponent {
  surveyList: Array<Survey>;
  location_id: string;
  locationName: string;
  loading: boolean = true;

  constructor(private surveys: SurveyService,
              private session: SessionService,
              private route: ActivatedRoute,
              private locationService: AgencyLocationService) { }

  ngOnInit() {
    const agencyId = this.session.agency_id;
    const params = new URLSearchParams();
    params.set('agency_id', agencyId);
    params.set('limit', '10000');

    this.location_id = this.route.snapshot.params['location_id'];

    this.surveys.list({search: params})
      .subscribe(res => {
        this.surveyList = res;
        this.loading = false;
      });

    this.locationService.detail(this.location_id)
      .subscribe(res => {
        this.locationName = res.semantic_name || res.name;
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/survey-list/survey-list.component.ts